import { Autocomplete, AutocompleteProps } from 'src/shared/form/autocomplete';
import { EvseModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/ocpi/src/protocol/v2.1.1/models/evse.model';

type Props = Pick<
  AutocompleteProps<EvseModel>,
  'onChange' | 'label' | 'errorMessage' | 'isTouched'
> & {
  readonly evseList: EvseModel[];
};

export function EvseSelect(props: Props): React.JSX.Element {
  const { evseList, ...autocompleteProps } = props;

  return (
    <Autocomplete
      disabled={evseList.length === 0}
      options={evseList}
      isOptionEqualToValue={(option, value) => option.evse_id === value.evse_id}
      getOptionLabel={(option) => option.evse_id ?? option.uid}
      {...autocompleteProps}
    />
  );
}
